import constants from './constants';
import { trackPromise } from 'react-promise-tracker';
import { getPriorAuthorizationService } from '../../services/planDetailsService';
const {
    SET_PRIOR_AUTH_BEGIN,
    SET_PRIOR_AUTH_SUCCESS,
    SET_PRIOR_AUTH_ERROR,
    SET_PRIOR_AUTH_CLEANUP
  } = constants;

  export const setPriorAuthBegin = () => ({
    type: SET_PRIOR_AUTH_BEGIN
  });
  
  export const setPriorAuthSuccess = data => ({
    type: SET_PRIOR_AUTH_SUCCESS,
    payload: { data }
  });
  
  export const setPriorAuthError = (error, index) => ({
    type: SET_PRIOR_AUTH_ERROR,
    payload: { error , index}
  });
  
  export const setPriorAuthClean = () => ({
    type: SET_PRIOR_AUTH_CLEANUP
  });

  export const getPriorAuthorization = (memberAccountHeader, tenantId, index) => {
    return (dispatch) => {
      dispatch(setPriorAuthBegin());
      trackPromise(
        getPriorAuthorizationService(memberAccountHeader, tenantId)
              .then(res => dispatch(setPriorAuthSuccess(res.data)))
              .catch(err => dispatch(setPriorAuthError(err, index)))
          );
      };
  };